import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import AppShell from "@/components/AppShell";
import AuthGate from "@/components/AuthGate";
import UploadBatch from "@/pages/UploadBatch";
import BatchProcessing from "@/pages/BatchProcessing";
import CandidateQueue from "@/pages/CandidateQueue";
import CandidateReview from "@/pages/CandidateReview";
import VendorResolutionDesk from "@/pages/VendorResolutionDesk";
import SentToEcView from "@/pages/SentToEcView";
import ValidationDashboard from "@/pages/ValidationDashboard";
import BillReview from "@/pages/BillReview";
import BillsHome from "@/pages/BillsHome";
import BillDetail from "@/pages/BillDetail";
import ExpensesHome from "@/pages/ExpensesHome";
import BillsHomeCockpit from "@/pages/BillsHomeCockpit";
import MoreHub from "@/pages/MoreHub";
import LandedCostPolicy from "@/pages/LandedCostPolicy";
import VendorDirectory from "@/pages/VendorDirectory";
import VendorDetail from "@/pages/VendorDetail";
import ExpenseDetail from "@/pages/ExpenseDetail";
import NeedsAttention from "@/pages/NeedsAttention";
import { SessionProvider } from "@/contexts/SessionContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SessionProvider>
          <AuthGate>
            <AppShell>
              <Routes>
                <Route path="/" element={<BillsHomeCockpit />} />
                <Route path="/capture" element={<UploadBatch />} />
                {/* Legacy alias — "/" used to be Capture. */}
                <Route path="/upload" element={<UploadBatch />} />
                <Route path="/more" element={<MoreHub />} />
                <Route path="/settings/landed-cost" element={<LandedCostPolicy />} />
                <Route path="/attention" element={<NeedsAttention />} />
                <Route path="/expenses/:expenseId" element={<ExpenseDetail />} />
                <Route path="/batches/:batchId" element={<BatchProcessing />} />
                <Route path="/queue" element={<CandidateQueue />} />
                <Route path="/candidates/:candidateId" element={<CandidateReview />} />
                <Route path="/vendors" element={<VendorDirectory />} />
                <Route path="/vendors/resolve" element={<VendorResolutionDesk />} />
                <Route path="/vendors/:vendorId" element={<VendorDetail />} />
                <Route path="/legacy/expense-capture" element={<SentToEcView />} />
                {/* Legacy aliases — old links continue to work. */}
                <Route path="/sent-to-ec" element={<SentToEcView />} />
                <Route path="/confirmed" element={<SentToEcView />} />
                <Route path="/validation" element={<ValidationDashboard />} />
                <Route path="/bills" element={<BillsHome />} />
                <Route path="/bills/detail/:billId" element={<BillDetail />} />
                <Route path="/bills/:candidateId" element={<BillReview />} />
                <Route path="/expenses" element={<ExpensesHome />} />
              </Routes>
            </AppShell>
          </AuthGate>
          <Toaster richColors position="top-right" />
        </SessionProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
